import Actions from '../../odata/actions';

const actions = new Actions('payrollSheetItem', 'payrollSheetItems');

export default actions;
